import { type CustomComponents, Flex, Text } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

import { type SmartSearchSelectOption } from '../resultKindConfig';
import SearchResultDisplayOptionPicker from './SearchResultDisplayOptionPicker';

type CustomComponentOptionProps = {
  data: SmartSearchSelectOption;
};

const NoOptionsMessage = () => {
  const { t } = useTranslation('common');

  return (
    <Flex hAlignContent="center" vertical>
      <Text variant="label-small">{t('smartSearch.noResultsMessage')}</Text>
      <Text mt="1rem" variant="label-small">
        {t('smartSearch.noResultsHelper')}
      </Text>
    </Flex>
  );
};

export const searchResultCustomComponents: CustomComponents = {
  Option: ({ data: resultItem }: CustomComponentOptionProps) => {
    return <SearchResultDisplayOptionPicker resultItem={resultItem} />;
  },
  NoOptionsMessage,
};
